import { Environment } from '@models';

export const environment: Environment = {
  production: false,
  apiRootUrl: '/api',
  serverApiRootUrl: 'https://api.dev.icaredx.app',
  directoryPortalUrl: 'https://dev.icaredx.app',
  patientPortalUrl: 'https://patient.dev.icaredx.app',
  smartFormTemplateId: 'smart-form-template-v1',
  marketingBaseUrl: 'https://marketing.icaredx.app',
};
